import { GridColDef } from '@mui/x-data-grid';
import { baseCell } from 'components/cells/BaseCell';
import {
  booleanFilterOperators,
  dateFilterOperators,
  filterOperators,
  numberFilterOperators,
  singleSelectFilterOperators
} from 'components/enhanced';

const GLOBAL_BASE_CONFIG: Partial<GridColDef> = {
  minWidth: 100,
  sortable: true,
  filterable: true,
  renderCell: baseCell,
  filterOperators: filterOperators
};

const FILTER_OPERATORS_MAP: Record<string, any> = {
  number: numberFilterOperators,
  date: dateFilterOperators,
  dateTime: dateFilterOperators,
  boolean: booleanFilterOperators,
  singleSelect: singleSelectFilterOperators,
  string: filterOperators
};

export type CustomGridColDef<T = any> = Omit<Partial<GridColDef<T>>, 'field'> & {
  field: keyof T | string;
  visible?: boolean;
};

export const createColumns = <T,>(
  columns: CustomGridColDef<T>[],
  t?: (key: string) => string,
  prefix?: string,
  customGridDefaults: Partial<GridColDef<T>> = {}
): GridColDef[] => {
  const processedColumns: GridColDef[] = [];

  for (let i = 0; i < columns.length; i++) {
    const col = columns[i];

    if (col.visible === false) continue;

    const { visible, field, type = 'string', ...muiColProps } = col;
    const stringField = String(field);

    const headerName =
      muiColProps.headerName ??
      (t ? (prefix ? t(`${prefix}.${stringField}`) : t(`global.${stringField}`)) : stringField);

    const filterOperators =
      muiColProps.filterOperators ?? (FILTER_OPERATORS_MAP[type] || FILTER_OPERATORS_MAP.string);

    const layoutProps = !muiColProps.width && !muiColProps.flex ? { flex: 1 } : {};

    processedColumns.push({
      ...GLOBAL_BASE_CONFIG,
      ...customGridDefaults,
      field: stringField,
      type,
      headerName,
      filterOperators,
      ...layoutProps,
      ...muiColProps
    } as GridColDef);
  }

  return processedColumns;
};
